<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="85px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="联系人姓名" prop="name">
            <el-input v-model="queryParams.name" placeholder="请输入联系人姓名" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="联系人角色" prop="businessRoleList">
            <el-select v-model="queryParams.businessRoleList" placeholder="请选择" clearable multiple style="width:100%">
              <el-option v-for="dict in roleOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="queryParams.mobile" placeholder="请输入手机号" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="所属区域" prop="area">
            <el-cascader v-model="queryParams.area" :options="areaOptions" :props="{ checkStrictly: true }" style="width:100%" filterable clearable></el-cascader>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :autoSelectUser="autoSelectUser"></dept-user-select>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="联系人姓名" width="100" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.name}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="联系人角色" width="110" align="center" prop="businessRole"/>
      <el-table-column label="客户名称" min-width="200" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="120" align="center" fixed="left">
        <template slot-scope="scope">
          <el-button type="text" title="点击获取完整手机号" v-if="scope.row.mobile.indexOf('**')>=0"
                     @click="queryMobile(scope.row)">{{ scope.row.mobile }}</el-button>
          <span v-else>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="部门" width="100" align="center" prop="apartment" show-overflow-tooltip/>
      <el-table-column label="职务" width="80" align="center" prop="position" show-overflow-tooltip/>
      <el-table-column label="立场" width="80" align="center" prop="standScore"/>
      <el-table-column label="所属区域" width="150" align="center" prop="areaName"/>
      <el-table-column label="负责人" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.manager ? scope.row.manager.managerName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进记录" min-width="150" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Boolean(scope.row.lastFollowInfo)" style="text-align: left;">
            <span v-if="scope.row.lastFollowInfo.followTypeDesc">{{scope.row.lastFollowInfo.followTypeDesc}} 跟进：<br></span>
            <span>{{scope.row.lastFollowInfo.content}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进人" width="100" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.followerName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进时间" width="175" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.createTime : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="80" align="center" prop="createUserName"/>
      <el-table-column label="创建时间" width="175" align="center" prop="createTime" />
      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="handleFollow(scope.row)">跟进</el-button>
          <el-button type="text"  @click="handlePlan(scope.row)">计划</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
    <PlanAddDialog ref="planAddDialogRef" @success="getList"></PlanAddDialog>
    <AddContactDialog ref="addContactDialogRef" @success="getList"></AddContactDialog>
  </div>
</template>

<script>
import {listContact, queryMobile} from "@/api/crm/contact";
import {desensitizeMobile, transferCascaderOptionsForProvince} from '@/utils/index'
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import PlanAddDialog from "@/views/crm/plan/planAddDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import AddContactDialog from "@/views/crm/contact/addContactDialog";
import { mapState } from 'vuex'
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import {listAllLevelArea} from "@/api/crm/area";

export default {
  name: "ContactManage",
  data() {
    return {
      desensitizeMobile,
      autoSelectUser: true,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      // relationClueFlagLst: [
      //   { id: 1, label: "有"},
      //   { id: 2, label: "无"}
      // ],
      roleOptions: [], // 角色列表
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        businessRoleList: [],
        customerName: null,
        mobile: null,
        area: [],
        createTime: [],
        deptIdList: [],
        managerIdList: []
      },
      areaOptions: []
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    AssignDialog,
    FollowAddDialog,
    PlanAddDialog,
    AddContactDialog,
    deptUserSelect
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    let workParams = this.$route.params // 工作台跳转进来
    if(Object.keys(workParams).length){
      this.autoSelectUser = false
      this.queryParams.createTime = workParams.createTime
      this.queryParams.deptIdList = workParams.deptIdList
      this.queryParams.managerIdList = workParams.managerIdList
    }else {
      this.autoSelectUser = true
    }
    this.getDicts("business_contact_role").then(response => {
      this.roleOptions = response.data;
    });
    this.getList();
    listAllLevelArea({ level: 2 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0]
        params.endDate = params.createTime[1]
      }
      params.createTime = undefined;
      params.provinceCode = params.area && params.area.length > 0 ? params.area[0] : null;
      params.cityCode = params.area && params.area.length > 1 ? params.area[1] : null;
      params.area = undefined;
      listContact(params).then(response => {
          this.dataList = response.rows || [];
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.createTime = []
      this.queryParams.deptIdList = []
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/contact/detail/" + row.id, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("contact", row.id);
    },
    /** 计划按钮操作 */
    handlePlan(row) {
      this.$refs.planAddDialogRef.open("contact", row.id, !row.manager ? null : row.manager.managerId);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addContactDialogRef.open();
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("contact", this.ids)
    },
    queryMobile(row){
      const loading = this.$loading({lock: true, text: '查询中', spinner: 'el-icon-loading'});
      queryMobile({
        id: row.id
      }).then(response => {
        if (response.data) {
          row.mobile = response.data
        }
      }).finally(error => {
        loading.close()
      })
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-table{
  .cell{
    line-height: normal!important;
  }
}
</style>
